export const gateNames = {
  credentialingSaas: 'admin_saas_credentials',
  blockCreateNewRateSettings: 'fg_block_create_new_rate_settings',
  blockPostShifts: 'fg_block_post_shifts',
  autoGeneratedRatesReview: 'fg_auto_generated_rates_review',
  basePayRateAutomation: 'fg_base_pay_rate_automation',
  disableMarkupsForW2Assignments: 'fg_disable_markups_for_w2_assignments',
};
